import styled from 'styled-components';

export const StyledContainer = styled.div`
    max-width: 1328px;
    margin: 0 auto;
    padding: 0 16px;
`